import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
    useTab,
} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_APRVAPP_DTL } from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import {
    APIS as IQS_APIS,
    URLS as IQS_URLS,
    getIqsAccessData,
} from "@/tz/go/egaz/osci/ptl/mypg/iqs/services/OsciMypgIqsService";
import { APP_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_GEN";
import { APP_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_TRPT";
import { APP_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_INVC";
import { APP_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ITM";
import { APP_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ATCM";
import { APP_DTL_PAY_INFO } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_PAY_INFO";
import { APP_DTL_MSG } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_MSG";
import { APP_DTL_DCLR } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_DCLR";

/**
 * LPCO Application Detail
 * !== LPCO 신청서 상세 ==!
 */
export const OSCI0201002S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: [
            "auth_osci0001",
            "auth_osci0006",
            "auth_osci0007",
            "auth_osci0008",
            "auth_osci0015",
            "auth_osci0016",
            "auth_osci0017",
            "auth_osci0009",
        ],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { appId } = useParams();

    const location = useLocation();
    const [appParam, setAppParam] = useState<any>({ ...(location.state ?? {}) });

    let tabSchemaList: any = [];

    const [gnrl, setGnrlVisible] = useState(false);
    const [trpt, setTrptVisible] = useState(false);
    const [invc, setInvcVisible] = useState(false);
    const [itm, setItmVisible] = useState(false);
    const [atcm, setAtcmVisible] = useState(false);
    const [payInfo, setpayInfoVisible] = useState(false);
    const [msg, setMsgVisible] = useState(false);
    const [dclr, setDclrVisible] = useState(false);
    const [cfrm, setCfrmVisible] = useState(false);

    const [comnCdList, setComnCdList] = useState([]);

    const [tansad, setTansadVisible] = useState(false);

    // Accessible IQS ID for IQS button !== IQS 버튼용 접근 가능 IQS ID ==!
    const [iqsId, setIqsId] = useState("");

    // Health Certificate print target LPCO app codes (DLD) !== 건강 증명서 인쇄 대상 LPCO 신청서 코드 (DLD) ==!
    const HLTH_CRTE_APP_CD_NOS = [
        // Export Permit for Live Animal !== 살아있는 동물 수출 허가서 ==!
        "OGAZ0041SW0003",
        // Export Permit for Animal Product !== 동물성 제품 수출 허가서 ==!
        "OGAZ0041SW0005",
    ];

    /*
     * Application Detail Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Application Ddtail Info Form !== 신청서 상세 정보 Form ==!
        newAppDtl: useForm({
            defaultSchema: SF_APRVAPP_DTL,
            defaultValues: {
                // ...(pgeStore?.form || {}),
            },
        }),
    };
    const appAprvNo = form.newAppDtl.watch("appAprvNo");

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        if (comnCdList && comnCdList.length > 0) {
            handler.changeTab(0);
        }
    }, [comnCdList]);

    /*
     * Pre-Application Tab
     * !== 탭 정의 ==!
     */
    const tab = {
        tabSchema: useTab({
            defaultSchema: {
                id: "tab",
                schema: tabSchemaList,
            },
        }),
    };

    /*
     * Master Applidation Details Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppInfo: useFetch({
            api: (appId) => APIS.getAppInfo({ appId: appId, orgCd: auth.get("orgCd") }),
            onSuccess: (data) => {
                const content = data?.appInfo?.content ?? {};
                form.newAppDtl.setValues({ ...content });
                if (content.cstmOfceCd && content.tansadYy && content.tansadSrno) {
                    setTansadVisible(true);
                }
                // Check IQS only for applications not yet completed (AP/RJ/CL) !== 처리 완료(AP/RJ/CL) 전 신청서만 IQS 확인 ==!
                if (content.appStatCd !== "AP" && content.appStatCd !== "RJ" && content.appStatCd !== "CL") {
                    fetch.getIqsId.fetch(content.appId);
                }
                setAppParam({ ...content });
                location.state = { ...content };
                handler.getTabSchemaList(content);
            },
            onError: (error) => {},
        }),
        // Get the accessible IQS ID !== 접근 가능한 IQS ID 조회 ==!
        getIqsId: useFetch({
            api: (appId) => IQS_APIS.getIqsIdByBsopId(appId, getIqsAccessData(auth)),
            onSuccess: (data) => {
                setIqsId(data?.iqsId?.content ?? "");
            },
            onError: (error) => {},
        }),
        getRprt: useFetch({
            api: () => {
                return lpcoUtils.getRprtLpco(
                    appParam.appId,
                    ["AP", "CL"].indexOf(form.newAppDtl.getValue("appStatCd")) > -1 ? "N" : "Y",
                );
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        // Get Health Certificate Report !== 건강 증명서 보고서 미리보기 조회 ==!
        getRprtHlthCrte: useFetch({
            api: () => {
                return lpcoUtils.getRprtHlthCrte(appParam.appId, "N");
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
    };

    /*
     * Application Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            await handler.getAppInfo(appId);
            await render.tabView();
        },
        // Get Pre-Application Information !== 사전신청서 정보 조회 ==!
        getAppInfo: async (appId: any) => {
            fetch.getAppInfo.fetch(appId);
        },
        getTabSchemaList: async (data: any) => {
            const reqParam = { orgCd: data.orgCd, appCdNo: data.appCdNo, appTpCd: data.appTpCd };
            const comnCdList = await lpcoUtils.getCpntList(reqParam);
            comnCdList.map((item: any) => {
                if ("CON" != item.value) {
                    tabSchemaList.push({ label: item.label });
                }
            });
            tab.tabSchema.setSchema(tabSchemaList);
            setComnCdList(comnCdList);

            handler.changeTab(0);
        },
        // Hide existing tab contents when changing tab !== Tab변경 시 기존 탭 내용 숨김처리  ==!
        chanageTabVisible: () => {
            setGnrlVisible(false);
            setTrptVisible(false);
            setInvcVisible(false);
            setItmVisible(false);
            setAtcmVisible(false);
            setCfrmVisible(false);
        },
        // Tab change event !== Tab변경 이벤트 ==!
        changeTab: async (index: any) => {
            handler.chanageTabVisible();
            let tabList = comnCdList;
            if (tabList && tabList.length > 0) {
                const tabInfo: any = tabList[index];
                switch (tabInfo.value) {
                    case "GEN":
                        setGnrlVisible(true);
                        break;
                    case "TRN":
                        setTrptVisible(true);
                        break;
                    case "INV":
                        setInvcVisible(true);
                        break;
                    case "ITM":
                        setItmVisible(true);
                        break;
                    case "ATC":
                        setAtcmVisible(true);
                        break;
                    case "PAY":
                        setpayInfoVisible(true);
                        break;
                    case "MSG":
                        setMsgVisible(true);
                        break;
                    case "DCL":
                        setDclrVisible(true);
                        break;
                    // case "CON":
                    //     setCfrmVisible(true);
                    //     break;
                }
            }
            tab.tabSchema.setActive(index);
        },
    };

    const render = {
        tabView: () => {
            const tabPanelList: any = [];
            const tabList = comnCdList;
            if (tabList != undefined) {
                tabList.map((item: any) => {
                    if ("GEN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{gnrl && <APP_DTL_GEN state={appParam} />}</Tab.Panel>,
                        );
                    } else if ("TRN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{trpt && <APP_DTL_TRPT state={appParam} />}</Tab.Panel>,
                        );
                    } else if ("INV" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{invc && <APP_DTL_INVC state={appParam} />}</Tab.Panel>,
                        );
                    } else if ("ITM" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{itm && <APP_DTL_ITM state={appParam} />}</Tab.Panel>,
                        );
                    } else if ("ATC" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{atcm && <APP_DTL_ATCM state={appParam} />}</Tab.Panel>,
                        );
                    } else if ("PAY" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{payInfo && <APP_DTL_PAY_INFO state={appParam} />}</Tab.Panel>,
                        );
                    } else if ("MSG" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{msg && <APP_DTL_MSG state={appParam} />}</Tab.Panel>,
                        );
                    } else if ("DCL" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{dclr && <APP_DTL_DCLR state={appParam} />}</Tab.Panel>,
                        );
                    }
                });
            }
            return tabPanelList;
        },
    };

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: "L_CO_LCNE" }, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNo} />
                            <Group.Control {...form.newAppDtl.schema.ucrNo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNm} />
                            <Group.Control {...form.newAppDtl.schema.appTpNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.sbmtDtm} />
                            <Group.Control {...form.newAppDtl.schema.aprvDtm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appStatNm} />
                            <Group.Control {...form.newAppDtl.schema.appXpirDt} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.nregYn} />
                            <Group.Label {...form.newAppDtl.schema.tansadNo} />
                            {tansad && (
                                <>
                                    <Group.Field
                                        as="link"
                                        onClick={() => {
                                            modal.openModal({
                                                url: `${
                                                    lpcoEnvs.base
                                                }/lpco/tansad/osci0202002q/${form.newAppDtl.getValue(
                                                    "cstmOfceCd",
                                                )}-${form.newAppDtl.getValue("tansadYy")}-${form.newAppDtl.getValue(
                                                    "tansadSrno",
                                                )}`,
                                                draggable: true,
                                                callback: (data) => {
                                                    modal.closeModal();
                                                },
                                            });
                                        }}
                                    >
                                        <Group.Control {...form.newAppDtl.schema.cstmOfceCd} />
                                        <Group.Any>-</Group.Any>
                                        <Group.Control {...form.newAppDtl.schema.tansadYy} />
                                        <Group.Any>-</Group.Any>
                                        <Group.Control {...form.newAppDtl.schema.tansadSrno} />
                                    </Group.Field>
                                </>
                            )}
                            {!tansad && <Group.Field />}
                        </Group.Row>

                        {appAprvNo && (
                            <Group.Row>
                                <Group.Control {...form.newAppDtl.schema.appAprvNo} controlSize={10} />
                            </Group.Row>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    navigate(URLS.osci0201001q);
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            {iqsId && (
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        modal.openModal({
                                            url: `${IQS_URLS.osci0102003s}/${iqsId}`,
                                            size: "md",
                                            draggable: true,
                                            callback: (data) => {
                                                modal.closeModal();
                                            },
                                        });
                                    }}
                                >
                                    {t("B_IQS")}
                                </Button>
                            )}
                            {appParam?.appStatCd === "AP" &&
                                HLTH_CRTE_APP_CD_NOS.includes(appParam?.appCdNo) && (
                                    <Button
                                        variant="secondary"
                                        onClick={() => {
                                            fetch.getRprtHlthCrte.fetch();
                                        }}
                                    >
                                        {t("B_HLTH_CRTE")}
                                    </Button>
                                )}
                            {appParam?.appStatCd === "AP" && (
                                <Button
                                    variant="secondary"
                                    onClick={() => {
                                        fetch.getRprt.fetch();
                                    }}
                                >
                                    {t("B_PRNT")}
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab
                        {...tab.tabSchema.tab}
                        onChange={(index) => {
                            // 탭이 변경되었을때 index 번호와 onChange 이벤트를 호출
                            handler.changeTab(index);
                        }}
                    >
                        {render.tabView()}
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
